import ProfileMessagesIntermediationService from "@services/profile-messages-intermediation-service";
import { initialiseComponents } from "../../core";
import Component from "../component.abstract";

interface ProfileMessageIntermediationProps {
  datetimeLabel: string;
  firstImageLink: string;
  buttonLink: string;
  secondButtonLink: string;
  companyName: string;
  message: string;
  secondMessage: string;
  isNew: boolean;
  state: string;
  trackingsClick: any;
}

export default class ProfileMessageIntermediation extends Component {
  private elDate: HTMLElement;
  private elImage: HTMLElement;
  private elMessage: HTMLElement;
  private elButtons: HTMLElement;
  private elButtonYes: HTMLElement;
  private elButtonNo: HTMLElement;
  private states = ["waiting", "accepted", "refused"];
  constructor(
    private props: ProfileMessageIntermediationProps,
    element: HTMLElement
  ) {
    super(props, element);
  }

  mounted(): void {
    this.injectTemplate();

    initialiseComponents();

    this.elDate = this.element.querySelector("[data-pm-date]");
    this.elImage = this.element.querySelector("[data-pm-image]");
    this.elMessage = this.element.querySelector("[data-pm-message]");
    this.elButtons = this.element.querySelector("[data-pm-buttons]");
    this.elButtonYes = this.element.querySelector("[data-pm-button-yes]");
    this.elButtonNo = this.element.querySelector("[data-pm-button-no]");

    this.setFields();
    this.setHandlers();
  }
  setFields(): void {
   this.elDate.innerText = 
        this.props.datetimeLabel;
        let img: HTMLImageElement | HTMLElement;
        if(this.props.firstImageLink) {
            img = new Image(105, 60);
            (<HTMLImageElement>img).src = this.props.firstImageLink;
            img.classList.add('message-intermediation-body-pictures-logo');
        } else {
            img = document.createElement('div')
            img.classList.add('message-intermediation-body-pictures-anonymous');
        }
        this.elImage.appendChild(img);

        if(this.props.secondButtonLink) {
          this.elMessage.innerHTML = 
            "<a href=\"" + this.props.secondButtonLink + "\">" + this.props.companyName + "</a>" +
            " " + this.props.message + "<br>" + this.props.secondMessage;
        } else {
          this.elMessage.innerHTML = 
            this.props.companyName +
            " " + this.props.message + "<br>" + this.props.secondMessage;
        }

        if (this.props.isNew === true) {
          this.element.classList.add("new");
        }

        if (this.props.state) {
          this.setState(this.props.state);
        }

        this.element.classList.add("loaded");
  }
  setHandlers(): void {
    this.elButtonYes.addEventListener("click", () => {
      //Add tracking click on accept opportunity
      if (this.props.trackingsClick && this.props.trackingsClick.length) {
        window.dataLayer.push(this.props.trackingsClick[0]);
      }

      this.call("true", 2);
    })
    this.elButtonNo.addEventListener("click", () => {
      //Add tracking click on refuse opportunity
      if (this.props.trackingsClick && this.props.trackingsClick.length) {
        this.props.trackingsClick[0].EventLibelle =
            "[EC-Mes-Opportunites] - Intermediation - Non";
        window.dataLayer.push(this.props.trackingsClick[0]);
      }

      this.call("false", 3);
    });
  }
  setState(state: string):void {
      const stateResult = this.states[parseInt(state) - 1];
      this.elButtons.classList.add(stateResult);
  }
  call(accepted:string, state: number):void {
      this.elButtons.classList.add("pending");
      const url = this.props.buttonLink + "&accept=" + accepted;
      const service = new ProfileMessagesIntermediationService(url);
      service.post({},(response:any) => {
           setTimeout( () => {
             this.element.classList.remove("new");
             this.setState(state.toString());
             this.elButtons.classList.remove("pending");
           }, 250);
      });
  }
}
